import { render } from "./KasimoDarbai.vue?vue&type=template&id=3e2da852"
import script from "./KasimoDarbai.vue?vue&type=script&lang=js"
export * from "./KasimoDarbai.vue?vue&type=script&lang=js"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__